import { Injectable } from '@angular/core';
import { ControlType, iApplyFormControl, isContainerControl } from 'app/shared/model';
import _ from 'lodash';

@Injectable()
export class ControlHelperService {
    findOne(controlList, findFn) {
        for (var i = 0; i < controlList.length; i++) {
            if (findFn(controlList[i])) {
                return controlList[i];
            }

            if (controlList[i].hasOwnProperty('Controls') || controlList[i].hasOwnProperty('controls')) {
                var match = this.findOne((controlList[i].Controls || controlList[i].controls), findFn);
                if (match) {
                    return match;
                }
            }
        }
        return null;
    };

    findNearestRepeater(controlList: iApplyFormControl[], control: iApplyFormControl): iApplyFormControl {
        if (!control.parentControlId) {
            return null;
        }

        let parent = this.findById(controlList, control.parentControlId);
        if (!parent) {
            return null;
        }

        if (parent.type === ControlType.Repeater) {
            return parent;
        }

        return this.findNearestRepeater(controlList, parent);
    };

    // TODO: Should return a "Qualifier" object.
    getControlPath(control: iApplyFormControl, controlList: iApplyFormControl[]): string[] {
        let path = [];
        while (!!control && !!control.parentControlId) {
            control = this.findById(controlList, control.parentControlId);
            if (control && control.type === ControlType.Repeater) {
                path.unshift(control.name);
            }
        }

        return path; //.join('.');
    }

    isValueControl(type: ControlType) {
        return false === [
            ControlType.Summary,
            ControlType.Search,
            ControlType.Calculation,
            ControlType.Repeater,
            ControlType.Group,
            ControlType.Html,
            ControlType.Heading,
            ControlType.Label,
            ControlType.Page].includes(type);
    };

    findAll(controlList: iApplyFormControl[], findFn): iApplyFormControl[] {
        let list = [];
        for (const control of controlList) {
            if (findFn(control)) {
                list.push(control);
            }
            if (isContainerControl(control)) {
                list = list.concat(this.findAll(control.controls, findFn));
            }
        }
        return list;
    }

    findByName(controlList: iApplyFormControl[], controlName: string): iApplyFormControl {
        if (!controlList) {
            return null;
        }

        // let result = controlList.findOne('name', controlName);
        let result = _.find(controlList, { 'name': controlName });
        if (result) {
            return result;
        }

        for (const control of controlList) {
            if (isContainerControl(control)) {
                result = this.findByName(control.controls, controlName);
                if (result) {
                    return result;
                }
            }
        }

        return null;
    }

    findById(controlList: iApplyFormControl[], controlId: number): iApplyFormControl {
        if (!controlList) {
            return null;
        }

        let result = _.find(controlList, { 'id': controlId });
        if (result) {
            return result;
        }

        for (const control of controlList) {
            if (isContainerControl(control)) {
                result = this.findById(control.controls, controlId);
                if (result) {
                    return result;
                }
            }
        }

        return null;
    }

    findByType<T>(controlList: iApplyFormControl[], controlType: ControlType): T[] {
        let result = [];
        for (const control of controlList) {
            if (control.type === controlType) {
                result.push(<T>control);
            }
            if (isContainerControl(control)) {
                result = result.concat(this.findByType(control.controls, controlType));
            }
        }

        return result;
    }
}
